import { MessageListEntity } from 'generated/graphql';
import { isMessageUnread } from './messageFlagsUtils';

const getUnseenMessagesCount = (messageCollection: MessageListEntity[], messageUids: number[]): number =>
  messageUids
    .map((messageId) => messageCollection.find((message) => message.uid === messageId))
    .filter((message) => message && isMessageUnread(message)).length;

export default getUnseenMessagesCount;
